import api from "../../api";
import UIComponent from "../../ui/component";
import goals from "../../utils/goals";


export class FolderManager extends UIComponent {
    firstClickCreateFolder = 'first-click-create-folder';
    firstClickAnyFolder = 'first-click-any-folder';

    init() {
        // this.folderLists = this.findAll("[data-folder-list]");
        // this.createFolderButtons = this.findAll( "[data-action='create-folder']");
        this.requireComponents({
            'createFolderModal': "document@#CreateFolderModal",
        });


        this.newFolderBtn.on('click', () => {
            this.goalFirstClick(this.firstClickCreateFolder, 'NewFolder');
            this.createFolderModal.show();
        });

        if (this.newFolderBtnMobile) {
            this.newFolderBtnMobile.on('click', () => {
                this.goalFirstClick(this.firstClickCreateFolder, 'NewFolder');
                this.createFolderModal.show();
            });
        }




        // if (!this.checkSessionKey(this.firstClickAnyFolder)) {
        //     this.folderLinks.on('click', this.handleClickFolder.bind(this));
        //     this.folderLinksMob?.on('click', this.handleClickFolder.bind(this));
        // }

        // if (!this.folderLists || this.folderLists.length === 0) return;
        // if (!modalEl) return;

        // this.currentFolderId = this.getCurrentFolderId();
        // this.initializeModal(modalEl);
        // this.setupEventListeners();
        // this.loadInitialFolders();
        // this.updateNoFolderUrl();
    }

    getCurrentFolderId() {
        const params = new URLSearchParams(window.location.search);
        return params.get("filters[folder_id]");
    }

    goalFirstClick(key, goal) {
        if (this.checkSessionKey(key)) return;

        window.sessionStorage.setItem(key, true);
        goals.reach(goal);
    }

    checkSessionKey(key) {
        return Boolean(window.sessionStorage.getItem(key));
    }

    handleClickFolder(ev) {
        if (this.checkSessionKey(this.firstClickAnyFolder)) return;

        const path = ev.composedPath();
        for (let i = 0; i <= path.length; i++) {
            if (path[i]?.nodeType === 1 && path[i]?.classList.contains('folder-button')) {
                this.goalFirstClick(this.firstClickAnyFolder, 'OpenFolder');
                break;
            }
        }
    }

    // initializeModal(modalEl) {
    //     this.modalInstance = new FileCreateModal(modalEl, {
    //         onCreate: async (name) => {
    //             try {
    //                 const response = await api.post("/api/folders", { name });
    //                 if (!response.success && !response.id) {
    //                     throw new Error(
    //                         response.message || "Ошибка при создании папки"
    //                     );
    //                 }

    //                 if (response.id) {
    //                     const newFolder = {
    //                         id: response.id,
    //                         name: name,
    //                     };
    //                     this.appendNewFolder(newFolder);
    //                     // this.updateCurrentFolder(response.id, name);
    //                 }

    //                 return true;
    //             } catch (error) {
    //                 return { error: error.message };
    //             }
    //         },
    //     });
    // }

    // async loadInitialFolders() {
    //     try {
    //         const response = await api.get("/api/folders");
    //         this.renderInitialFolders(response);
    //     } catch (error) {
    //         console.error("Ошибка загрузки папок:", error);
    //     }
    // }

    // renderInitialFolders(folders) {
    //     const fragment = document.createDocumentFragment();

    //     folders.forEach((folder) => {
    //         fragment.appendChild(this.createFolderElement(folder));
    //     });

    //     this.folderLists.forEach((listEl) => {
    //         listEl.innerHTML = "";
    //         listEl.appendChild(fragment.cloneNode(true));
    //         this.highlightCurrentFolder(listEl);
    //     });
    // }

    // highlightCurrentFolder(listEl) {
    //     if (this.currentFolderId) {
    //         const currentFolder = listEl.querySelector(
    //             `[data-folder-id="${this.currentFolderId}"]`
    //         );
    //         if (currentFolder) {
    //             currentFolder.classList.add("active-folder");
    //             const icon = currentFolder.querySelector("img.folder-icon");
    //             if (icon) {
    //                 icon.src = "/img/icons/move.svg";
    //             }
    //         }
    //     }
    // }

    // appendNewFolder(folder) {
    //     if (
    //         this.folderLists[0].querySelector(`[data-folder-id="${folder.id}"]`)
    //     ) {
    //         return;
    //     }

    //     const folderElement = this.createFolderElement(folder);
    //     // Эт какой-то ужас, а не компонанта, но пока так...
    //     this.folderLists.forEach((listEl) => {
    //         if (!folderElement) return;
    //         const clonedElement = folderElement.cloneNode(true);

    //         clonedElement.style.opacity = "0";
    //         clonedElement.style.transform = "translateY(10px)";
    //         listEl.appendChild(clonedElement);

    //         setTimeout(() => {
    //             clonedElement.style.transition =
    //                 "opacity 0.3s ease, transform 0.3s ease";
    //             clonedElement.style.opacity = "1";
    //             clonedElement.style.transform = "translateY(0)";
    //         }, 50);
    //     });
    // }

    // updateCurrentFolder(folderId, folderName) {
    //     const url = new URL(window.location.href);
    //     url.searchParams.set("filters[folder_id]", folderId);
    //     url.searchParams.set("folder_name", folderName);
    //     window.history.pushState({}, "", url.toString());


    //     this.currentFolderId = folderId;

    //     this.folderLists.forEach((listEl) => {
    //         listEl.querySelectorAll(".active-folder").forEach((el) => {
    //             el.classList.remove("active-folder");
    //             const icon = el.querySelector("img.folder-icon");
    //             if (icon) {
    //                 icon.src = "/img/icons/close-folder.svg";
    //             }
    //         });

    //         const currentFolder = listEl.querySelector(
    //             `[data-folder-id="${folderId}"]`
    //         );
    //         if (currentFolder) {
    //             currentFolder.classList.add("active-folder");
    //             const icon = currentFolder.querySelector("img.folder-icon");
    //             if (icon) {
    //                 icon.src = "/img/icons/move.svg";
    //             }
    //         }
    //     });

    //     document.dispatchEvent(
    //         new CustomEvent("folderChanged", {
    //             detail: { id: folderId, name: folderName },
    //         })
    //     );
    // }

    // createFolderElement(folder) {
    //     const templateFolder =  this.folderLists[0].querySelector("[data-folder-id]");
    //     if (!templateFolder) return null;

    //     const folderButton = templateFolder.cloneNode(true);

    //     const url = new URL(window.location.href);
    //     url.pathname = url.pathname.replace(/\/\d+$/, "");
    //     url.search = "";
    //     url.searchParams.set("filters[folder_id]", folder.id);
    //     url.searchParams.set("folder_name", folder.name);

    //     folderButton.href = url.toString();
    //     folderButton.dataset.folderId = folder.id;
    //     folderButton.title = folder.name;

    //     const icon = folderButton.querySelector("img");
    //     if (icon) {
    //         icon.src = "/img/icons/close-folder.svg";
    //         icon.classList.add("folder-icon");
    //     }

    //     const nameSpan = folderButton.querySelector(".span-action-folder");
    //     if (nameSpan) {
    //         nameSpan.textContent = folder.name;
    //         nameSpan.title = folder.name;
    //     }

    //     return folderButton;
    // }

    // updateNoFolderUrl() {
    //     if (!this.noFolder || !this.noFolder.element) return;

    //     const url = new URL(window.location.href);
    //     url.pathname = url.pathname.replace(/\/\d+$/, "");
    //     url.search = "";
    //     url.searchParams.set("filters[folder_id]", "0");

    //     this.noFolder.element.href = url.toString();
    // }

    // setupEventListeners() {
    //     this.createFolderButtons.forEach((button) => {
    //         button.addEventListener("click", (e) => {
    //             e.preventDefault();
    //             this.modalInstance.show();
    //         });
    //     });
    // }
}
